import { render, staticRenderFns } from "./PersonStatutoryInfoNew.vue?vue&type=template&id=fef8ac6e"
import script from "./PersonStatutoryInfoNew.vue?vue&type=script&lang=js"
export * from "./PersonStatutoryInfoNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports